"use strict";
$(function () {
    const ARROWLEFT = 37;
    const ARROWUP = 38;
    const ARROWRIGHT = 39;
    const ARROWDWN = 40;
    const ENTER = 13;
    const ESC = 27;
    let searchdata;
    const searchSelector = $('.search-main__input').length ? 'search-main' : 'search';
    const searchControl = $(`.${ searchSelector }__input`);

    $('body').on('keydown',function (e) {
        if(e.which===ESC){
            updateSearch(searchControl, []);
            searchControl.val('');
        }
    }).on('mousedown',function(){
        updateSearch(searchControl, []);
    });

    $(`.${searchSelector}__wrap`).mousedown(function (e) {
        e.stopPropagation();
    });

    $(`.${ searchSelector }__dropdown`).on('mouseenter', `.${ searchSelector }__dropdown-item`, function() {
        $(`.${ searchSelector }__dropdown-item`).removeClass(`${ searchSelector }__dropdown-item--active`);
        $(this).addClass(`${ searchSelector }__dropdown-item--active`);
    })

    $.ajax({
        'type': 'GET',
        beforeSend: function (jqXHR) {
            // set request headers here rather than in the ajax 'headers' object
            // jqXHR.setRequestHeader('Accept-Encoding', 'br');
        },
        'datatype': 'text',
        'url': '/preload',
        'success': function (data) {
            searchdata = data;
        },
        'error': function (a, b, c) {}
    });

    $('.search__icon,.search-main__icon').on('click',function (e) {
        doSearch(e);
    })
    searchControl.on('keydown', function (e) {

        switch (e.which) {
            case ENTER:
                e.preventDefault();
                return doSearch(e);
            case ARROWUP:
            case ARROWDWN:
                e.preventDefault();

                let visible = 0;
                const items = $(`.${ searchSelector }__dropdown-item`);

                items.each(function(cx, elem){
                    $(this).removeData('index');
                    if(checkVisible(elem,20)){
                        visible++;
                        $(this).data('index', cx);
                    }
                });

                if (visible === 0) return;

                let selected = $(`.${ searchSelector }__dropdown-item--active`);
                let index = selected.length ? selected.data('index') : 0;
                if (e.which === ARROWDWN) {
                    index = selected.length ? ++index % visible : 0;
                } else if (e.which === ARROWUP) {
                    index = selected.length ? ( index ? index - 1 : visible - 1) : visible - 1;
                }

                items.each(function() {
                    const cx = $(this).data('index');
                    $(this).toggleClass(`${ searchSelector }__dropdown-item--active`, cx === index);
                })
                break;
        }
    }).on('paste', function() {
        $(this).trigger('keyup');
    }).on('keyup', function(e) {

        if ([ARROWUP, ARROWDWN, ARROWLEFT, ARROWRIGHT].includes(e.which)) return;
        const self = $(this);
        let token = self.val().toLowerCase();
        let prev = self.data('prev');

        if (token === prev) return;
        self.data('prev', token);

        if (token.length === 0) return updateSearch(self, []);
        if (token.length > 60) return updateSearch(self, [], true);
        if (token.length < 4) {

            let subToken = '';
            let subSearch = searchdata;
            for (let i = 0; i < token.length; i++) {
                let l = token[i];
                subToken += l;
                if (typeof subSearch[l] !== 'undefined') {
                    subSearch = subSearch[l];
                } else {
                    subSearch = [];
                    subSearch['_'] = [];
                    break;
                }
            }
            let results = [];
            for (let i = 0; i < subSearch['_'].length; i++) {
                results.push(token + subSearch['_'][i]);
            }
            return updateSearch($(this), results, true);
        }

        $.ajax({
            'type': 'GET',
            'datatype': 'JSON',
            'url': '/search/' + token,
            'success': function (data) {
                updateSearch(self, data, true);
            }
        });
    })

    function updateSearch(element, wordlist, setActive = false) {
        element.parent().toggleClass(`${ searchSelector }__wrap--active`, wordlist.length > 0 || setActive);
        let dropdown = $(`.${ searchSelector }__dropdown-list`, element.parent());

        dropdown.html('');
        const uniqWords = [...new Set(wordlist)];
        uniqWords.forEach(item => {

            const li = $('<li/>').addClass(`${ searchSelector }__dropdown-item`);
            const link = $('<a/>').attr('href', makeTypedHref(item)).addClass('d-block').text(item);
            li.append(link);
            dropdown.append(li);
        })

        if (setActive && wordlist.length === 0) {

            // const custom = $('<li/>').addClass(`${ searchSelector }__dropdown-item`).text('Нет результатов');
            dropdown.append('<li>&nbsp;</li>');
            dropdown.append('<li>&nbsp;</li>');
            dropdown.append('<li>&nbsp;</li>');
            // dropdown.append(custom);
        }
    }

    function doSearch(e) {

        e.stopImmediatePropagation();
        e.stopPropagation();

        // active item has two classes and after sort will be at first position...
        // if there are no active item first will be just fine
        let word = $(`.${ searchSelector }__dropdown-item`).sort((a, b) => b.classList.length - a.classList.length).first().text();

        if (!word) return;
        goToWord(word)
    }
});

const makeTypedHref = (currentWord) => {
    const word = currentWord.trim();
    let parts = decodeURI(location.pathname).split('/');

    // ['', 'слова-и-выражения-на', 'ху', '']
    // ['', 'слово', 'папа', 'предложения', '']
    if (parts.length > 4 || parts[1] !== 'слово') {
        parts[1] = 'слово';
        parts = parts.slice(0, 4);
    }
    parts[2] = word;
    return parts.join('/').replace(/\/+$/gu, '').trim();
}

function checkVisible(elm, threshold, mode) {
    threshold = threshold || 0;
    if(typeof mode === 'undefined'){
        mode = 'visible';
    }

    let rect = elm.getBoundingClientRect();
    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    let above = rect.bottom - threshold < 0;
    let below = rect.top - viewHeight + threshold >= 0;

    return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
}

function goToWord(word) {
    location.assign(makeTypedHref(word));
}
